interface ExperienceDataType {
    title: string;
    date: string;
    details: string[];
  }
  
  export const ExperienceData: ExperienceDataType[] = [
    {
      title: 'UI/UX Designer | TechPool',
      date: 'June 2023 - Sep 2023',
      details: [
        "Designed a tech website that showcases the company's services & vision in a captivating way.", "Implemented complex animations and transitions to engage users and visually communicate Techpool's values and offerings.", "Tested different design elements and layouts to identify the most eective solutions.", "Utilized Figma tool, including prototyping, design systems, and collaboration features, to deliver high-quality website designs.",
      ],
    },
      {
      title: 'Frontend Developer | Lazarus Network',
      date: 'Oct 2022 - Nov 2022',
      details: [
        'Built a dynamic web app using React.js, integrating various APIs to deliver key functionalities', 'Designed and implemented user interfaces and user experiences for both the web app and browser extension', 'Implemented prioritized navigation, clear information hierarchy, and responsive design for optimal usability across devices', 'Collaborated closely with the development team to identify and resolve bugs, ensuring smooth operation and a positive user experience',
      ],
    },
  ];
